'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { useLayoutContext } from '@/context/LayoutContext'
import { usePageScrollSmooth } from '@/hooks/usePageScrollSmooth'
import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'

function PublicProfilePageWrapper({
  children,
  isVideoPage,
}: PropsWithChildren<{ isVideoPage: boolean }>) {
  const { headerHeight } = useLayoutContext()

  useBIPageView()
  usePageScrollSmooth()

  return (
    <main
      className={cn('h-full overflow-x-clip', !isVideoPage && 'mb-20')}
      data-section="creator-profile"
      style={{
        marginTop: isVideoPage ? 0 : headerHeight,
      }}
    >
      {children}
    </main>
  )
}

export default PublicProfilePageWrapper
